import oAxiosInstance from "config/Axios";

export const apiCallGetAllCompanies = () => {
  return oAxiosInstance.get("companies");
};
